import { defineMessages } from 'react-intl'

const scope = `procurify.expenses.ExpenseDetailPage`

export default defineMessages({
  pageTitle: {
    id: `${scope}.pageTitle`,
    defaultMessage: 'Expense details',
  },
  expenseStatusBreadcrumb: {
    id: `${scope}.expenseStatusBreadcrumb`,
    defaultMessage: 'Expense status',
  },
  expenseApprovalsBreadcrumb: {
    id: `${scope}.expenseApprovalsBreadcrumb`,
    defaultMessage: 'Expense approvals',
  },
})
